import * as Yup from 'yup';

// The order of these is important due to the validation running sequentially.
// Whatever order these are in is the order that the input focusing will occur in if there is an erorr.
export default Yup.object().shape({
  valueAndTaxInfo: Yup.object().shape({
    amountToBeRefunded: Yup.string(),
    amountOfferedInSettlement: Yup.string(),
    amountPaid: Yup.string(),
    assets: Yup.array().of(
      Yup.object().shape({
        yearsOfDeliquency: Yup.string(),
        taxes: Yup.string(),
        penaltyFees: Yup.string(),
        interest: Yup.string(),
        total: Yup.string(),
      })
    ),
    currMarketValue: Yup.string(),
    id: Yup.string(),
  }),
});
